// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"16f8bb52","186":"f9433553","198":"f223a520","225":"969626ab","344":"c83cdaa8","372":"45d75f71","703":"48955639","738":"33e0abe8","841":"10133f5f","856":"fd4e8a72"}[chunkId] + ".chunk.js";
};